import AuthorDetailPage from "./author-detail.page";

export default AuthorDetailPage;
